import React from "react";
import axios from "axios";
import { url } from "../../../../../App";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import SingleDocModal from "../Modals/SingleDocModal";
import MultiDocsModal from "../Modals/MultiDocsModal";
import Cookies from "js-cookie";
// import { useNavigate } from "react-router";

const ViewLoanDoc = ({
  loanDetails,
  docName,
  title,
  closeModal,
  openLoader,
  closeLoader,
  modalType,
  isDownload,
  isDelete
}) => {
  // const Navigate = useNavigate();
  console.log(loanDetails)
  console.log(docName, 'docname');
  console.log(title, 'title');
  console.log(closeLoader);


  const [modalData, setModalData] = useState({});

  const [modalArr, setModalArr] = useState([]);
  const [multiDocsModal, setMultiDocsModal] = useState(false);
 const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  // const [token, setToken] = useState("");

  //eslint-disable-next-line
  const viewBorrowerDocument = async () => {
    //TODO   setLoader(true);
    openLoader();
    if (!loanDetails[docName]) {
      closeLoader();
      return toast.error("Document does not Exist");
    }
    const req = {
      borrower_uniqueno: localStorage.getItem("uniqueID"),
      doc_name: loanDetails[docName].doc_name ?? docName,
      doc_type: loanDetails[docName]?.doc_type,
      token,
      email,
      loan_id: loanDetails.loan_id,
    };
    const res = await axios.post(url + "/loan/viewdoc", req);
    // console.log(req, res.data);
    closeLoader();
    const downloadDocumentHandler = async () => {
      openLoader();
      let imgDoc;
      if (req.doc_type === "pdf") {
        imgDoc = "application";
      } else {
        imgDoc = "image";
      }
      openLoader();
      const downloadRes = await axios.post(url + "/loan/downloaddoc", req);
      closeLoader();
      if (!downloadRes.data.auth) {
        toast.error(downloadRes.data.message);
      }
      const linkSource = `data:${imgDoc}/${req.doc_type};base64,${downloadRes.data.doc_base64}`;
      const downloadLink = document.createElement("a");
      console.log(req.doc_type);
      const fileName = `${req.borrower_uniqueno} ${title}.${req.doc_type}`;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      closeLoader();
    };
    const deleteDocHandler = async () => {
      const text = `Are you sure you want to delete this document?`;
      if (!window.confirm(text)) {
        return;
      }
      openLoader();
      const deleteReq = {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        borrower_uniqueno: localStorage.getItem("uniqueID"),
        loan_id: loanDetails.loan_id,
        doc_arr: {
          location: loanDetails[docName].location,
          doc_type: loanDetails[docName].doc_type,
          doc_name: loanDetails[docName].doc_name,
        },
      };
      const deleteRes = await axios.post(
        url + "/loan/deletedoc",
        deleteReq
      );
      closeLoader();
      if (!deleteRes.data.auth) {
        toast.error(deleteRes?.data.message);
        return;
      }
      toast.success(deleteRes.data.message);
      window.location.reload();
    };
    return {
      doc: res.data?.doc_base64,
      docType: req.doc_type,
      download: downloadDocumentHandler,
      delete: deleteDocHandler,
    };
  };

  const fetchMultiDocs = async () => {
    openLoader();
    try{
      const docsArray = await Promise.all(
        loanDetails[docName].map(async (data) => {
          const req = {
            borrower_uniqueno: localStorage.getItem("uniqueID"),
            doc_name: data?.doc_name ?? "",
            doc_type: data?.doc_type,
            loan_id: loanDetails.loan_id,
            token: Cookies.get("Token"),
            email: Cookies.get("Email"),
          };
          console.log(req)
          const res = await axios.post(url + "/loan/viewdoc", req);
          // if (!res.data?.auth) {
          //   return;
          // }
          closeLoader();
          const downloadDocumentHandler = async () => {
            openLoader();
            let imgDoc;
            if (req.doc_type === "pdf") {
              imgDoc = "application";
            } else {
              imgDoc = "image";
            }
            const downloadRes = await axios.post(
              url + "/loan/downloaddoc",
              req
            );
            closeLoader();
            if (!downloadRes.data.auth) {
              toast.error(downloadRes.data.message);
              closeLoader();
            }
            const linkSource = `data:${imgDoc}/${req.doc_type};base64,${downloadRes.data.doc_base64}`;
            const downloadLink = document.createElement("a");
            console.log(req.doc_type);
            const fileName = `${req.borrower_uniqueno} ${title}.${req.doc_type}`;
            console.log(title);
            console.log(fileName);
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          };
          const deleteDocHandler = async () => {
            const text = `Are you sure you want to delete this document?`;
            if (!window.confirm(text)) {
              return;
            }
            openLoader();
            const deleteReq = {
              token: Cookies.get("Token"),
              email: Cookies.get("Email"),
              borrower_uniqueno: localStorage.getItem("uniqueID"),
              loan_id: loanDetails.loan_id,
              doc_arr: {
                location: data?.location,
                doc_type: data?.doc_type,
                doc_name: data?.doc_name,
              },
            };
            const deleteRes = await axios.post(
              url + "/loan/deletedoc",
              deleteReq
            );
            closeLoader();
            if (!deleteRes.data.auth) {
              toast.error(deleteRes?.data.message);
              return;
            }
            toast.success(deleteRes.data.message);
            window.location.reload();
          };
          return {
            doc: res.data?.doc_base64,
            docType: req?.doc_type,
            download: downloadDocumentHandler,
            delete: deleteDocHandler,
          };
        })
      );
      setModalArr(docsArray);
    }catch(err){
      console.log(err)
      closeLoader()
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!Array.isArray(loanDetails[docName])) {
          setMultiDocsModal(false);
          const doc = await viewBorrowerDocument();
          setModalData(doc);
        } else {
          setMultiDocsModal(true);
          const doc = await fetchMultiDocs();
          setModalData(doc);
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
    //eslint-disable-next-line
  }, []);

  return (
    <>
      {/* <ToastContainer /> */}
      {multiDocsModal ? (
        <MultiDocsModal
          title={title}
          closeModal={closeModal}
          array={modalArr}
          docName={docName}
          isDelete={isDelete}
          isDownload={isDownload}
        />
      ) : (
        <SingleDocModal
          title={title}
          closeModal={closeModal}
          doc={modalData?.doc}
          docType={modalData?.docType}
          isDownload={isDownload && modalData?.download}
          isDelete={isDelete && modalData.delete}
        />
      )}
    </>
  );
};

export default ViewLoanDoc;
